module.exports = __webpack_public_path__ + "img/or-divider.dbeaaf56.svg";